module.exports = __webpack_public_path__ + "static/media/20ECE16.41a79798.jpg";